export const UNASSIGNED_TAG_TYPE = 'unassigned';

export const TAG_TYPES = [UNASSIGNED_TAG_TYPE, 'untagged', 'vlan_tagged'];

export const TAG_TYPES_METADATA = {
  [UNASSIGNED_TAG_TYPE]: {title: 'Unassigned', color: 'grey'},
  untagged: {title: 'Untagged', color: 'violet'},
  vlan_tagged: {title: 'VLAN Tagged', color: 'teal'}
};
